import React, { ReactNode } from "react";
import { observer } from "mobx-react-lite";
import { Flex } from "@fluentui/react-northstar";
import styles from "./mobileViewCardDetailsItem.module.scss";
import { constants } from "shared/constants";
import { RegularText } from "shared/components";

export interface MobileViewCardDetailsItemProps {
    label?: string;
    content?: ReactNode;
}

export const MobileViewCardDetailsItem: React.FC<MobileViewCardDetailsItemProps> = observer((props) => {
    return (
        <Flex fill vAlign="center" column className={styles.container}>
            {props.label && <RegularText isLabel content={props.label} />}
            <div>
                {props.content ?? <RegularText content={constants.noValue} />}
            </div>
        </Flex>
    );
});
